import '/assets/styles/layouts/account.scss';
import config from '/config';
import PropTypes from 'prop-types';

// Sections
import Header from '/views/sections/header'
import Footer from '/views/sections/footer'

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useBreakpoints } from "@wearetla/tla-essentials-tools/utilities/breakpoints";

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder'

const CheckoutLayout = ({ children, sectionClass }) => {
	const { activeRoute, redirect } = useNavigator();
	const { mobile } = useBreakpoints();
	const { initialized, loggedIn, userData, logout: contextLogout } = useAuth();

	const showMenu = (initialized && loggedIn);

	const logout = () => {
		contextLogout().then(() => {
			if(activeRoute?.requiresLogin) {
				redirect('home');
			}
		})
	}

	return (
		<>
			<Header />
			<div className={`page account ${mobile ? '' : 'wrapper'}`}>
				{!mobile &&
					<aside className="section account-menu">
						<div className="menu-userinfo">
							<Icon name="account" />
							{showMenu ?
								<strong className="userinfo-name">{userData?.name} <span className="userinfo-surname">{userData.surname}</span></strong>
								:
								<Placeholder className="userinfo-name"></Placeholder>
							}
						</div>

						<ul className="menu-list">
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.orders' ? ' active' : '')}
									href="account.orders">
									<Icon className="link-icon" name="box" />
									Siparişlerim
								</Link>
							</li>
							{config.enableLoyalty &&
								<li className="list-item">
									<Link
										className={'item-link' + (activeRoute?.key === 'account.loyaltyInfo' ? ' active' : '')}
										href="account.loyaltyInfo">
										<Icon className="link-icon" name="logo" />
										Kalbim Kart Programı
									</Link>
								</li>
							}
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.children' ? ' active' : '')}
									href="account.children">
									<Icon className="link-icon" name="baby" />
									Bebek Bilgilerim
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.info' ? ' active' : '')}
									href="account.info">
									<Icon className="link-icon" name="contact" />
									Üyelik Bilgilerim
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.addresses' ? ' active' : '')}
									href="account.addresses">
									<Icon className="link-icon" name="address" />
									Adreslerim
								</Link>
							</li>

							<li className="list-item apart">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.reviews' ? ' active' : '')}
									href="account.reviews">
									<Icon className="link-icon" name="comment" />
									Değerlendirmelerim
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.giftCodes' ? ' active' : '')}
									href="account.giftCodes">
									<Icon className="link-icon" name="discount" />
									Hediye Çeklerim
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.favorites' ? ' active' : '')}
									href="account.favorites">
									<Icon className="link-icon" name="heart-empty" />
									Favorilerim
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.alarms' ? ' active' : '')}
									href="account.alarms">
									<Icon className="link-icon" name="notification" />
									Alarmlarım
								</Link>
							</li>
							<li className="list-item">
								<Link
									className={'item-link' + (activeRoute?.key === 'account.messages' ? ' active' : '')}
									href="account.messages">
									<Icon className="link-icon" name="message" />
									Mesajlarım
								</Link>
							</li>
							<li className="list-item apart">
								<button
									className="item-link"
									onClick={logout}>
									<Icon className="link-icon" name="logout" />
									Çıkış Yap
								</button>
							</li>
						</ul>
					</aside>
				}
				<div className={'section account-page account-page-' + sectionClass }>
					{children}
				</div>
			</div>
			<Footer />
		</>
	)
}

CheckoutLayout.propTypes = {
	children: PropTypes.node,
	pageClass: PropTypes.string,
	loading: PropTypes.bool,
}

export default CheckoutLayout